export default __webpack_public_path__ + "static/media/LOGO FINAL verde.402f0e00.png";